<template>
  <div class="autocomplete">
    <input
      type="text"
      class="input"
      v-model="search"
      @input="select = false"
      :required="required"
    />
    <ul v-if="filterList.length > 0 && !select">
      <li v-for="(item, i) in filterList" :key="i + 'op'" @click="choice(item)">
        <template v-if="Array.isArray(name)">
          <span v-for="(n, i) of name" :key="'aitem' + i">
            <template v-if="i > 0"> - </template>
            {{ item[n] }}
          </span>
        </template>
        <template v-else>
          {{ item[name] }}
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    name: String,
    required: [String, Boolean],
  },
  data() {
    return {
      search: "",
      select: false,
    };
  },
  methods: {
    choice(item) {
      this.search = item[this.name];
      this.select = true;
      this.$emit("value", item);
    },
  },
  computed: {
    filterList() {
      if (this.search.length > 1 && !this.select) {
        const search = this.search.toLowerCase();
        return this.list.filter((item) => {
          for (let field in item) {
            if (item[field] && item[field].toString().toLowerCase().includes(search))
              return item;
          }
        });
      } else return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.autocomplete {
  input {
    width: 90%;
    /* height: 56px; */
    background: $white;
    border: 1px solid $white-6;
    font-size: 14px;
    color: $gray-5;
    border-radius: 23px;
    letter-spacing: 0.5px;
    padding: 0px 7px;
  /*   margin-top: 10px; */
  }

  ul {
    box-shadow: $shadow;
    position: absolute;
    z-index: 999;
    background: $white;
    max-height: 50%;
    overflow: auto;

    li {
      padding: 15px 10px;
      border-bottom: 1px solid #eee;

      cursor: pointer;

      &:hover {
        background: $gray-4;
        color: $white;
      }
    }
  }
}
</style>
